<template>
    <div>
        <header-kravicka
                @updateProfil="emitUpdateProfil"
                :profil="profil"
        />

        <main>

            <div class="container">

                <div class="row align-items-center h100vh">

                    <div class="col-md-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-0 text-center text-xl-left">

                        <span class="customLabel">Ahoj {{ userName }}</span>
                        <h1 class="smallerHeading">Poskladaj čo najrýchlejšie obrázok s kravičkou </h1>
                        <!-- TODO text-->
                        <p class="pexesoDescription">Vyskúšaj si svoju šikovnosť v známej hre sliding puzzle. Na výber máš tri obtiažnosti a rôzne motívy obrázkov. Kravička na púšti? Alebo radšej tá vo vesmíre? Tak šup, ukáž čo vieš.</p>

                        <div class="buttonsWrap">

                            <router-link
                                    class="btn --primary --large --startGame mb-2 mb-md-0"
                                    :to="{ name: 'slider-settings', params: { kravicka_id: $route.params.kravicka_id } }"
                            >
                                <span class="icon"></span>Spustiť hru
                            </router-link>

                            <router-link
                                    class="btn --secondary --trophy"
                                    :to="{ name: 'slider-leaders', params: { kravicka_id: $route.params.kravicka_id } }"
                            >
                                <span class="icon"></span>Tabuľka najlepších
                            </router-link>

                        </div>

                        <router-link
                            class="endGame"
                            :to="{name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id }}"
                        >
                            Ukončiť hru a vrátiť sa ku kravičke<span class="icon"></span>
                        </router-link>

                    </div>

                    <div class="col-xl-6 d-none d-xl-block">
                        <img src="assets/img/puzzleMainImg.png" alt="">
                    </div>

                </div>

            </div>

        </main>

        <div class="pexesoFooter --right d-none d-md-flex">

            <router-link
                    class="btn --primary closeGame"
                    :to="{name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id }}"
            >
                <span class="icon"></span>
            </router-link>

        </div>

    </div>

</template>

<script>
    // import EventService from '@/services/EventService.js'
    import HeaderKravicka from "../partials/HeaderKravicka.vue"

    export default {
        components: {HeaderKravicka},
        props: [
            'profil',
        ],
        data() {
            return {

            }
        },
        mounted() {
            this.toggleBodyClass('addClass', 'pexeso')
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'pexeso')
        },
        computed: {
            userName() {
                return this.profil.pouzivatel_id.pouzivatel_name
            }
        },
        methods: {
            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            emitUpdateProfil() {
                this.$emit('updateProfil')
            },
        }
    }

</script>